import { makeStyles } from '@material-ui/styles'
import Theme from '@refera/ui-core'

export default makeStyles(({ palette, spacing }) => ({
  container: {
    '& .MuiDrawer-paper': {
      display: 'flex',
      gap: spacing(4),
      flexDirection: 'column',
      height: '100vh',
      top: spacing(48),
      borderColor: palette.gray[12],
      transition: 'padding 0.3s ease-in-out, box-shadow 0.3s ease-in-out',
      backgroundColor: palette.custom.rhino,
    },
  },
  containerOpened: {
    '& .MuiDrawer-paper': {
      width: '328px',
      boxShadow: `${spacing(0, 4, 4)} rgba(0, 0, 0, 0.25)`,
    },
  },
  containerClosed: {
    '& .MuiDrawer-paper': {
      padding: spacing(16, 16, 0),
    },
  },

  historyHeader: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    width: '100%',
  },
  boxShadow: {
    boxShadow: `${spacing(0, 4, 4)} rgba(0, 0, 0, 0.25)`,
    padding: spacing(16, 24),
  },
  historyHeaderTitle: {
    display: 'flex',
    alignItems: 'center',
    gap: spacing(20),
  },
  timeLine: {
    color: 'white',
  },
  icon: {
    height: spacing(32),
    width: spacing(32),
    marginRight: 0,
  },
  content: {
    padding: spacing(24),
    display: 'flex',
    justifyContent: 'center',
    flexDirection: 'column',
  },
  chip: {
    borderRadius: spacing(24),
    textTransform: 'none',
    fontFamily: ['Roboto', 'sans-serif'],
    padding: spacing(6, 12),
    fontSize: '14px',
    lineHeight: '112.5%',
    cursor: 'pointer',
    margin: spacing(10, 0, 10),
  },
  chipEnabled: {
    backgroundColor: Theme.Colors.Primary.Base,
    color: 'white',
  },
  chipDisabled: {
    backgroundColor: 'transparente',
    border: '1px solid white',
    color: 'white',
  },
}))
